// On first paint, attempt a silent refresh. If a valid refresh cookie is
// present, this restores the access token without showing the login screen.

import { useEffect, useState } from "react";

import { ApiError, apiFetch } from "@/api/client";
import { setAuth } from "@/api/auth-store";
import type { TokenResponse } from "@/types/api";

export function useBootstrap(): { ready: boolean } {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const body = await apiFetch<TokenResponse>("/api/v1/auth/refresh", {
          method: "POST",
        });
        if (!cancelled) {
          setAuth({
            accessToken: body.access_token,
            scope: body.scope,
            role: body.role,
            tenantId: body.tenant_id,
          });
        }
      } catch (err) {
        if (!(err instanceof ApiError) || err.status !== 401) {
          // Network or unexpected — log but still let app render the login screen.
          console.warn("bootstrap refresh failed", err);
        }
      } finally {
        if (!cancelled) setReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { ready };
}
